import { AcademicYear, BackLink } from '.'

const mapStateToProps = state => {
  const {
    nav: { linkRoute, linkText, suppressLink },
  } = state
  return {
    linkRoute,
    linkText,
    suppressLink,
  }
}

const SecondaryNavigation = props => {
  const { suppressLink, linkRoute, linkText } = props
  const secondaryNavStyles = {
    border: 0,
    borderBottom: '1px solid #d9d9d9',
    background: '#fff',
    width: '100%',
    position: 'relative',
    padding: '10px 0',
    marginBottom: '20px',
  }

  if (!suppressLink) {
    if (linkRoute !== '' && linkText !== '') {
      return (
        <div style={secondaryNavStyles}>
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <BackLink linkText={linkText} linkRoute={linkRoute} />
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  return (
    <div style={secondaryNavStyles}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <AcademicYear />
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(SecondaryNavigation)
